import React from 'react';
import PerformanceAppraisalPage from '../appraisal/PerformanceAppraisalPage';
import ReportLayout from './ReportLayout';

const APPRAISAL_META = {
  'mid-year': {
    badge: 'Mid-Year Appraisal',
    title: 'My Mid-Year Report',
    description: 'View your self mid-year appraisal and print the current appraisal form as a PDF report.',
  },
  'year-end': {
    badge: 'Year-End Appraisal',
    title: 'My Year-End Report',
    description: 'View your self year-end appraisal and export the current appraisal form as a PDF report.',
  },
};

export default function AppraisalReportPage({ reportType }) {
  const meta = APPRAISAL_META[reportType] || APPRAISAL_META['mid-year'];

  return (
    <ReportLayout
      badge={meta.badge}
      title={meta.title}
      description={meta.description}
    >
      <PerformanceAppraisalPage reportType={reportType} readOnlyReport />
    </ReportLayout>
  );
}
